module.exports = __webpack_public_path__ + "static/media/icon_rename.53f8c8ad.svg";